module.exports = __webpack_public_path__ + "images/backgrounds/snow-bokeh/full.75b2ce11e6652e76ad0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/backgrounds/snow-bokeh/full.jpg
// module id = o7zL
// module chunks = 13